<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
  height: 100vh;
  width: 100vw;
}
body {
  margin: 0;
}
</style>
